import { SystemWorkOrderStatus } from '../../../../entities/job/system.workorder.status';
import { WorkOrder } from '../../../../entities/job/workorder';
import { WorkOrderStatusSystemName } from '../../../../entities/job/workorder.status.system.name';

export function stageIsCompletedOrLater(stage?: WorkOrder): boolean {

    const systemStatus = stage?.status?.systemStatus as SystemWorkOrderStatus;

    return systemStatus === SystemWorkOrderStatus.Completed || systemStatus === SystemWorkOrderStatus.Finalised || !!stage?.completedDate || !!stage?.finalisedDate;
}

export function stageIsFinalised(stage?: WorkOrder): boolean {

    const systemStatus = stage?.status?.systemStatus as SystemWorkOrderStatus;
    const systemName = stage?.status?.systemName as WorkOrderStatusSystemName;

    return systemStatus === SystemWorkOrderStatus.Finalised || systemName === WorkOrderStatusSystemName.Finalised || !!stage?.finalisedDate;
}

export function stageIsClosedOrCancelled(stage?: WorkOrder): boolean {

    const systemStatus = stage?.status?.systemStatus as SystemWorkOrderStatus;
    const systemName = stage?.status?.systemName as WorkOrderStatusSystemName;

    return systemStatus === SystemWorkOrderStatus.Closed || systemStatus === SystemWorkOrderStatus.Canceled || systemName === WorkOrderStatusSystemName.Closed || systemName === WorkOrderStatusSystemName.Canceled;
}
